export const checkPermission = (permissions, condition) => {
  if (permissions && permissions.indexOf(condition) > -1) {
    return true;
  } else {
    return false;
  }
};

export const checkPermissions = (permissions = [], conditions = []) => {
  if (conditions.length === 0) {
    return true;
  }
  const isShow = permissions.some((f) => conditions.indexOf(f) >= 0);
  return isShow;
};
